import Switch from 'react-switch';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import copy from 'fast-copy';

// import swal from '@sweetalert/with-react';
import Swal from 'sweetalert2'

import _ from 'lodash';

import { Button, LinearProgress as LoadingOverlay } from '@material-ui/core';
import {
  DataGridPro, useGridApiRef, GridFooter, GridFilterInputValue, frFR, enUS,
  GridToolbarContainer, GridToolbarFilterButton, GridToolbarColumnsButton,
  GridColumnMenuContainer, SortGridMenuItems, GridFilterMenuItem, CustomUserItem
} from '@mui/x-data-grid-pro';

import Print from './Print';
import Export from './Export';

import Create from './Create';
import Update from './Update';

import { useAppContext } from '../../../../Context/App/Provider';
// import { get, create, update, remove } from '../../../../Functions/admin';
// import { useAdminContext } from '../../../../Context/Admin/Provider';
import { useReportingContext } from '../../../../Context/Reporting/Provider';
import { useEventContext } from '../../../../Context/Event/Provider';
import { colors, roles, devicesTypeValues, useStateWithCallback, sharingValues, toastTimerValue } from '../../../../Shared/utils';
import { changeAdminColumns, changeSettings, activeGridFilter, setLocationGridValues, translatedGridFilters, getTimeAsZDateTime, getRandomPassword } from '../../../../Functions/utils';

import { updateScenariosOrder, updateScenarioColumnsOrder, updateSavedScenarios } from '../../../../Functions/user';

import { decodeHTMLEntities } from '../../../../Functions/utils';
import { createScenario, deleteScenario, getScenarios, updateScenario } from '../../../../Functions/scenarios';
// import { getGroups } from '../../../../Functions/reporting';


import '../Admin.css';
import '../../../SweetAlert.css'


export default function ScenariosList() {
  const { t } = useTranslation();
  const apiRef = useGridApiRef();

  const [{ settings, user }, appDispatch] = useAppContext();
  const [{ pickers, selected }, dispatch] = useReportingContext();
  const [{ groupsLocationsStatus, deploymentsStatus, scenariosStatus }, eventDispatch] = useEventContext();

  // const [initialSelectedLocations, setInitialSelectedLocations] = useState(selected.locations);
  // const [groups, setGroups] = useState([]);
  //const [scenarios2, setScenarios2] = useState([]);

  const [scenarios, setScenarios] = useState([]);

  const [loaded, setLoaded] = useState(!!scenarios);
  const [loading, setLoading] = useState(true);

  const [filterModel, setFilterModel] = useState({
    items: [],
    linkOperator: "and"
  });

  // const [filteredRows, setFilteredRows] = useState([]);

  const [databV2, setDatabV2] = useState([]);
  const [selectedScenario, setSelectedScenario] = useState(null);
  const [model, setModel] = useStateWithCallback({ filtered: null, selected: [] });

  const [sortModel, setSortModel] = useState([]);
  const [currentMovedColumns, setCurrentMovedColumns] = useState([]);

  const [modeScenariosOrModules, setModeScenariosOrModules] = useState(
    settings.mode === 'all_scenarios' ||
      settings.mode === 'myShared_scenarios' ||
      settings.mode === 'myPrivate_scenarios' ||
      settings.mode === 'sft_scenarios' ||
      settings.mode === 'allGroups_scenarios' ||
      settings.mode === 'currentGroups_scenarios' ? settings.mode : 'all_scenarios'
  );



  const handleSetModeScenariosOrModules = (mode) => {
    setModeScenariosOrModules(mode);
    document.querySelector('#modeScenariosOrModules').classList.toggle('open');
  };


  const CustomColumnMenu = (props) => {
    const { hideMenu, currentColumn, ...other } = props;

    return (
      <GridColumnMenuContainer
        hideMenu={hideMenu}
        currentColumn={currentColumn}
        {...props}
      >
        <SortGridMenuItems onClick={hideMenu} column={currentColumn} />
        <GridFilterMenuItem onClick={hideMenu} column={currentColumn} />
      </GridColumnMenuContainer>
    );
  }



  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit'
  };

  const [highlightedRow, setHighlightedRow] = useState(null);

  const [reordering, setReordering] = useState(null);
  const [reorderedColumn, setReorderedColumn] = useState("");

  const [oldIndex, setOldIndex] = useState(null);
  const [targetIndex, setTargetIndex] = useState(null);

  const [loadedColumnsFromDatabase, setLoadedColumnsFromDatabase] = useState(false);
  const [scenarioColumnsFromDatabase, setScenarioColumnsFromDatabase] = useState({});

  useEffect(() => {
    if (!loadedColumnsFromDatabase) {
      setLoadedColumnsFromDatabase(true);

      const scenarioColumnsOrder = user.scenarioColumnsOrder ? JSON.parse(user.scenarioColumnsOrder) : {};

      const allScenarioColumns = {
        id: { hide: true, order: 1, width: 100 },
        devicesType: { hide: false, order: 2, width: 140 },
        name: { hide: false, order: 3, width: 340 },
        creator: { hide: false, order: 4, width: 270 },
        sharedWith: { hide: false, order: 5, width: 240 },
        group: { hide: false, order: 6, width: 175 },
        creationDate: { hide: false, order: 7, width: 175 },
        lastEditionUser: { hide: false, order: 8, width: 190 },
        lastEditionDate: { hide: false, order: 9, width: 175 },
        // numberOfModules: { hide: false, order: 10, width: 220 },
        usedBy: { hide: false, order: 10, width: 300 },
        actions: { hide: false, order: 11, width: 150 }
      }

      for (const key of Object.keys(allScenarioColumns)) {
        if (scenarioColumnsOrder[key]) {
          allScenarioColumns[key] = scenarioColumnsOrder[key];
        }
      }

      const orderedKeys = Object.keys(allScenarioColumns)
        .sort((a, b) => {
          return allScenarioColumns[a].order > allScenarioColumns[b].order ? 1 : -1;
        });

      let i = 1;
      for (const key of orderedKeys) {
        allScenarioColumns[key].order = i;
        i++;
      }
      setScenarioColumnsFromDatabase(allScenarioColumns);
    }
  }, [loadedColumnsFromDatabase]);


  useEffect(() => {
    apiRef.current.subscribeEvent('columnHeaderDragStart', (params) => {
      setReordering(true);
      setReorderedColumn("");
      setOldIndex(null);
      setTargetIndex(null);
    });

    apiRef.current.subscribeEvent('columnHeaderDragEnd', (params) => {
      setReordering(false);
    });
  }, [apiRef]);


  useEffect(() => {
    if (reordering === false) {
      changeColumnsOrder(reorderedColumn, oldIndex, targetIndex);
      setReordering(null);
    }
  }, [reordering]);


  useEffect(() => {
    const dropdown = (e) => {
      if (typeof e.target.className === 'string' && !e.target.className.includes('dropdown')) {
        document.querySelector('#modeScenariosOrModules') && document.querySelector('#modeScenariosOrModules').classList.remove('open');
      }
    };
    document.addEventListener('click', dropdown);
    return () => document.removeEventListener('click', dropdown);
  }, [t]);


  // const [scenarioColumnsFromDatabase, setScenarioColumnsFromDatabase] = useState(
  //   user.scenarioColumnsOrder ?
  //     JSON.parse(user.scenarioColumnsOrder)
  //     :
  //     {
  //       id: { hide: true, order: 1, width: 100 },
  //       devicesType: { hide: false, order: 2, width: 140 },
  //       name: { hide: false, order: 3, width: 340 },
  //       creator: { hide: false, order: 4, width: 270 },
  //       sharedWith: { hide: false, order: 5, width: 240 },
  //       group: { hide: false, order: 6, width: 175 },
  //       creationDate: { hide: false, order: 7, width: 175 },
  //       lastEditionUser: { hide: false, order: 8, width: 190 },
  //       lastEditionDate: { hide: false, order: 9, width: 175 },
  //       // numberOfModules: { hide: false, order: 10, width: 220 },
  //       actions: { hide: false, order: 10, width: 150 }
  //     }
  // );

  let columns = [];

  if (scenarioColumnsFromDatabase.id) {
    columns = [ // default visible width: 1650
    {
      field: 'id',
      headerName: 'ID',
      hide: scenarioColumnsFromDatabase.id.hide,
      filterable: false,
      width: scenarioColumnsFromDatabase.id.width
    },
    {
      field: 'name',
      hide: scenarioColumnsFromDatabase.name.hide,
      width: scenarioColumnsFromDatabase.name.width,
      headerName: t('scenarios.name'),
      valueGetter: (params) => {
        return params.row.label;
      }
    },
    {
      field: 'creator',
      hide: scenarioColumnsFromDatabase.creator.hide,
      width: scenarioColumnsFromDatabase.creator.width,
      headerName: t('scenarios.creator'),
      valueGetter: (params) => {
        if (
          (user.roleId <= roles.stAdmin) ||
          (user.roleId > roles.stAdmin && params.row.creatorRole > roles.stAdmin)
        ) {
            if (params.row.creatorEmail && params.row.creatorEmail.includes('DEMO_USER_$'))
              return 'DEMO_USER';
          return params.row.creatorEmail;
        }
        return "";
      }
    },
    {
      field: 'sharedWith',
      hide: scenarioColumnsFromDatabase.sharedWith.hide,
      width: scenarioColumnsFromDatabase.sharedWith.width,
      headerName: t('scenarios.sharedWith'),
      type: 'singleSelect',
      valueOptions: [
        t('scenarios.no_one'),
        t('scenarios.everyone'),
        t('scenarios.allStAdmins'),
        t('scenarios.allGroupAdmins'),
        t('scenarios.allGroupAdmins'),
        t('scenarios.allGroupUsers')
      ],
      valueGetter: (params) => {
        switch (params.row.sharingOptions) {
          case 0:
            return t('scenarios.no_one');
            break;

          case 1:
            return t('scenarios.everyone');
            break;

          case 2:
            return t('scenarios.allStAdmins');
            break;

          case 3:
            return t('scenarios.allGroupAdmins');
            break;

          case 4:
            return t('scenarios.allGroupUsers');
            break;

          default:
            return "";
        }
      }
    },
    {
      field: 'group',
      hide: scenarioColumnsFromDatabase.group.hide,
      width: scenarioColumnsFromDatabase.group.width,
      headerName: t('scenarios.group'),
      valueGetter: (params) => {
        if (
          user.roleId <= roles.stAdmin &&
          params.row.sharingOptions !== sharingValues.everyone &&
          params.row.groups.length > 0
        ) {
          return user.groups.filter(group => params.row.groups.includes(group.id)).map(group => group.name).join(', ');
        }
        return ("")

      }
    },
    {
      field: 'creationDate',
      hide: scenarioColumnsFromDatabase.creationDate.hide,
      width: scenarioColumnsFromDatabase.creationDate.width,
      headerName: t('scenarios.creationDate'),
      type: 'date',
      renderCell: ({ row }) => {
        const creationtTxt = (row.creationDate) ? new Date(row.creationDate).toLocaleDateString(settings.lang ? settings.lang : 'en', options) : "...";

        if (
          (user.roleId <= roles.stAdmin) ||
          (user.roleId > roles.stAdmin && row.creatorRole > roles.stAdmin)
        )
          return (
            <div>
              {creationtTxt}
            </div>
          )

        return (
          <div>
          </div>
        )
      },
    },
    {
      field: 'lastEditionUser',
      hide: scenarioColumnsFromDatabase.lastEditionUser.hide,
      width: scenarioColumnsFromDatabase.lastEditionUser.width,
      headerName: t('scenarios.lastEditionUser'),
      valueGetter: (params) => {
        if (
          (user.roleId <= roles.stAdmin && params.row.lastUser)
        ) {
          return params.row.lastUser;
        }
        return "";
      }
    },
    {
      field: 'lastEditionDate',
      hide: scenarioColumnsFromDatabase.lastEditionDate.hide,
      width: scenarioColumnsFromDatabase.lastEditionDate.width,
      headerName: t('scenarios.lastEditionDate'),
      type: 'date',
      renderCell: ({ row }) => {
        const lastTxt = (row.lastEditionDate) ? new Date(row.lastEditionDate).toLocaleDateString(settings.lang ? settings.lang : 'en', options) : "...";

        if (
          (user.roleId <= roles.stAdmin && row.lastEditionDate)
        )
          return (
            <div>
              {lastTxt}
            </div>
          )

        return (
          <div>
            ...
          </div>
        )
      }
    },
    {
      field: 'devicesType',
      hide: scenarioColumnsFromDatabase.devicesType.hide,
      width: scenarioColumnsFromDatabase.devicesType.width,
      headerName: t('scenarios.type'),
      type: 'singleSelect',
      valueOptions: [
        'PCs',
        'Mobiles',
        'Disks'
      ],
      valueGetter: (params) => {
        switch (params.row.devicesType) {
          case devicesTypeValues.PCs: {
            return 'PCs';
          }

          case devicesTypeValues.mobiles: {
            return 'Mobiles';
          }

          case devicesTypeValues.disks: {
            return 'Disks';
          }
        }
      },
      renderCell: ({ row }) => {
        switch (row.devicesType) {
          case devicesTypeValues.PCs:
            return (
              <span
                className="material-icons"
                title={t('scenarios.devicesType_PCs')}
                style={{ height: 'auto', cursor: 'help' }}
              >laptop
              </span>
            );
            break;

          case devicesTypeValues.mobiles:
            return (
              <span
                className="material-icons"
                title={t('scenarios.devicesType_mobiles')}
                style={{ height: 'auto', cursor: 'help' }}
              >phone_iphone</span>
            )
            break;

          case devicesTypeValues.disks:
            return (
              <span
                className="material-icons"
                title={t('scenarios.devicesType_disks')}
                style={{ height: 'auto', cursor: 'help' }}
              >album</span>
            );
            break;

          default:
            return "";
        }
        return "";
      }
    },
    // {
    //   field: 'numberOfModules',
    //   hide: scenarioColumnsFromDatabase.numberOfModules.hide,
    //   width: scenarioColumnsFromDatabase.numberOfModules.width,
    //   headerName: t('scenarios.number_of_modules'),
    //   valueGetter: (params) => {
    //     return params.row && params.row.modules && params.row.modules.length
    //   },
    //   renderCell: ({ row }) => {
    //     return (
    //       <div>
    //         {row.modules.length}
    //       </div>
    //     )
    //   }
    // },

      ...(user.roleId <= roles.stAdmin ? [{
        field: 'usedBy',
        hide: scenarioColumnsFromDatabase.usedBy ? scenarioColumnsFromDatabase.usedBy.hide : false,
        width: scenarioColumnsFromDatabase.usedBy ? scenarioColumnsFromDatabase.usedBy.width : 350,
        headerName: t('scenarios.usedBy'),
        valueGetter: (params) => {
          if (params && params.row && params.row.usedBy && params && params.row && params.row.usedBy.length > 0) {

            const options = {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            };

            let strTmp = " ";
            for (const element of params.row.usedBy) {

              if (params.row.owner !== element.userId) {
                const dateTxt = (element.date) ? new Date(element.date).toLocaleDateString(settings.lang ? settings.lang : 'en', options) : "";

                if (strTmp !== " ")
                  strTmp += ", ";

                strTmp = strTmp + (element.userName) + (element.groupName ? " (" + element.groupName + ") " : " ") + dateTxt;
              }
            }
            return strTmp;
          }
          return ""
        }
      },] : []),

    {
      field: 'actions',
      headerName: 'Actions',
      hide: scenarioColumnsFromDatabase.actions.hide,
      width: scenarioColumnsFromDatabase.actions.width,

      sortable: false,
      filterable: false,

      align: 'right',
      headerAlign: 'right',

      renderCell: ({ row }) => {
        let forceDisabled = false;
        if (row.owner !== null && user.roleId >= roles.stAdmin) {
          forceDisabled = true;
          if (row.owner === user.id)
            forceDisabled = false;
        }

        return (
          <div>
            <Button
                disabled={loading}
              className="button icon"
              title={t('global.duplicate')}
              onClick={() => handleDuplicateScenario(row)}
            >
              <span className="material-icons-outlined" style={{ fontSize: '20px', padding: '0 2px' }}>copy</span>
            </Button>

            <Button
              disabled={loading || forceDisabled}
              title={t('global.update')}
              style={{ minWidth: 'unset' }}
              onClick={() => {
                return setSelectedScenario(row);
              }}
            >
              <span className="material-icons-outlined" style={{ color: '#222' }}>edit</span>
            </Button>
            <Button
              disabled={loading || forceDisabled}
              title={t('global.delete')}
              style={{ minWidth: 'unset' }}
              onClick={() => handleDeleteScenario(row)}
            >
              <span className="material-icons-outlined" style={{ color: '#f22' }}>delete</span>
            </Button>
          </div>
        )
      }
    }
  ] // Keep columns order between sessions
    .sort((a, b) => scenarioColumnsFromDatabase[a.field].order - scenarioColumnsFromDatabase[b.field].order);
  }

  // console.log("361 - columns=", columns);


  const handleDeleteScenario = ({ label, id }) => {
    const newText = label.replace(/ /g, ' ');

    Swal.fire({
      allowOutsideClick: false,
      title: t('global.dialog_title'),
      html: t('scenarios.delete.confirm', { label: newText }),
      input: "text",
      showCancelButton: true,
      confirmButtonText: t("global.ok"),
      cancelButtonText: t("global.cancel"),
      inputValidator: (value) => {
        const newValue = value.replace(/ /g, ' ');
        const newLabel = label.replace(/ /g, ' ');

        if (newValue != newLabel && value != label && newValue != label) {   // CHECK loc.label === value
          return t('scenarios.delete.validation');
        }
        return "";
      },
      customClass: {
        confirmButton: 'confirm-button-class',
        title: 'title-class',
        icon: 'icon-class'
      }
    }).then(async (value) => {
      console.log("563 - value=", value);
      // return;

      if (value && value.isConfirmed) {
        const newValue = value && value.value.replace(/ /g, ' ');
        const newLabel = label && label.replace(/ /g, ' ');

        // console.log("507 - value=", value, newValue, loc.label, newValue === loc.label);
        if (newValue === newLabel || value === label || newValue === label) {   // CHECK loc.label === value         

          setLoaded(false);
          setLoading(true);
          dispatch({ settingsScenarios: [] });

          const res = await deleteScenario(id);
          if (!res.success) {
            setLoaded(true);
            setLoading(false);
            return toast(decodeHTMLEntities(t('scenarios.errors.' + res, { label })), { type: 'error' });
          }

          setLoaded(true);
          setLoading(false);
          toast(decodeHTMLEntities(t('scenarios.delete.success', { label })), { type: 'success' });

          dispatch({ settingsScenarios: copy(scenarios).filter(s => s.id !== id) });
          setScenarios(copy(scenarios).filter(s => s.id !== id));

          eventDispatch({ scenariosStatus: "full-force", refreshScenarios: true });
        }
      }
    });
  };


  const handleDuplicateScenario = async (scenario) => {
    const label = scenario.label;

    // if (window.confirm(t('scenarios.duplicate.confirm' + (user.roleId <= roles.stAdmin ? '' : '_private'), { label }))) {
    setLoaded(false);
    setLoading(true);
    dispatch({ settingsScenarios: [] });

    scenario.label = label + ' - Copy';

    // console.log("82 - scenario=", scenario);
    if (scenario.groups.length === 0)
      scenario.groups.push(user.groupId);

    const locations = user.locations.map(loc => loc.id);

    const created = await createScenario(scenario);
    if (!created.success) {
      setLoaded(true);
      setLoading(false);
      return toast(decodeHTMLEntities(t('scenarios.errors.duplicate', { label })), { type: 'error' });
    }

    scenario.id = created.scenario.id;
    if (
      user.roleId > roles.stAdmin &&
      (
        scenario.sharingOptions === sharingValues.allStAdmins ||
        scenario.sharingOptions === sharingValues.everyone
      )
    ) {
      // Duplicate the scenario as a private one for non st-admins
      // scenario.locations = locations;
      if (user.email.includes('DEMO_USER_$'))
        scenario.sharingOptions = sharingValues.noOne;
      else
      scenario.sharingOptions = sharingValues.allGroupUsers;
    }
    scenario.allowModifications = false;

    const updated = await updateScenario(scenario);
    if (!updated.success) {
      await deleteScenario(scenario.id);

      setLoaded(true);
      setLoading(false);
      return toast(decodeHTMLEntities(t('scenarios.errors.duplicate', { label })), { type: 'error' });
    }

    const res = await getScenarios(locations, 1); // Refresh scenarios
    if (!res.success) {
      setLoaded(true);
      setLoading(false);
      return toast(decodeHTMLEntities(t('scenarios.errors.' + res)), { type: 'error' });
    }

    toast(decodeHTMLEntities(t('scenarios.duplicate.success', { label })), { type: 'success' });

    dispatch({ settingsScenarios: res.scenarios });
    setScenarios(res.scenarios);
    eventDispatch({ scenariosStatus: "full-force", refreshScenarios: true });

    setLoaded(true);
    setLoading(false);
  };




  const handleSortChange = (model) => {
    if (JSON.stringify(model) !== JSON.stringify(sortModel)) {
      setSortModel(model);
    }
  };

  const selectedOption = () => {

    if (!selectedScenario) return null;

    // console.log("549 - selectedScenario=", selectedScenario);

    return selectedScenario.id ? (
      <Update
        scenarios={scenarios}
        setScenarios={setScenarios}
        selectedScenario={selectedScenario}
        setSelectedScenario={setSelectedScenario}
      />
    ) : (
      <Create
        scenarios={scenarios}
        setScenarios={setScenarios}
        setSelectedScenario={setSelectedScenario}
      />

      //   locations={locations}
      //   setLocations={setLocations}
      //   setSelectedLocation={setSelectedLocation}
      //   databV2={databV2}
      //   setDatabV2={setDatabV2}
      // />
    )
  };




  const changeColumnsWidth = (col) => {
    // const prev = JSON.stringify(locationColumnsFromDatabase);
    // let newLocationColumns = locationColumnsFromDatabase;

    // if (newLocationColumns[col.colDef.field]) {
    //   newLocationColumns[col.colDef.field].width = col.width;
    //   const next = JSON.stringify(newLocationColumns);

    //   if (prev !== next) {
    //     updateLocationColumnsOrder(newLocationColumns);
    //     setLocationColumnsFromDatabase(newLocationColumns);

    //     const newUser = {
    //       ...user,
    //       locationColumnsOrder: next
    //     }
    //     appDispatch({ user: newUser });
    //   }
    // }
  }


  const changeColumnsVisibility = (col) => {
    // const prev = JSON.stringify(locationColumnsFromDatabase);
    // let newLocationColumns = locationColumnsFromDatabase;

    // if (newLocationColumns[col.colDef.field]) {
    //   newLocationColumns[col.colDef.field].hide = !col.isVisible;
    //   const next = JSON.stringify(newLocationColumns);

    //   if (prev !== next) {
    //     updateLocationColumnsOrder(newLocationColumns);
    //     setLocationColumnsFromDatabase(newLocationColumns);

    //     const newUser = {
    //       ...user,
    //       locationColumnsOrder: next
    //     }
    //     appDispatch({ user: newUser });
    //   }
    // }
  }

  const changeColumnsOrder = (reorderedColumn, oldIndex, targetIndex) => {

    const prev = JSON.stringify(scenarioColumnsFromDatabase);

    let ecart = targetIndex - oldIndex;
    if (ecart > 0)
      ecart = ecart + 0.5;
    else
      ecart = ecart - 0.5;

    let newScenarioColumns = {};
    for (const columnName in scenarioColumnsFromDatabase) {
      const column = scenarioColumnsFromDatabase[columnName];

      newScenarioColumns[columnName] = scenarioColumnsFromDatabase[columnName];

      if (columnName === reorderedColumn)
        newScenarioColumns[columnName].order = newScenarioColumns[columnName].order + ecart;
    }

    const orderedKeys = Object.keys(newScenarioColumns)
      .sort((a, b) => {
        return newScenarioColumns[a].order > newScenarioColumns[b].order ? 1 : -1;
      });

    let i = 1;
    for (const key of orderedKeys) {
      newScenarioColumns[key].order = i;
      i++;
    }
    const next = JSON.stringify(newScenarioColumns);

    if (prev !== next) {
      updateScenarioColumnsOrder(newScenarioColumns);
      setScenarioColumnsFromDatabase(newScenarioColumns);

      const newUser = {
        ...user,
        reportColumnsOrder: next
      }
      appDispatch({ user: newUser });
    }

    setReordering(null);
    setReorderedColumn("");
    setOldIndex(null);
    setTargetIndex(null);
  }


  const rowsToPrint = () => {
    const filtered = model.filtered ?? scenarios;

    // .slice() creates a new array
    const rows = filtered.slice().filter(loc => (
      model.selected.length > 0 ? model.selected.includes(loc.id) : loc.id > 0
    ));
    return rows;
  };

  const updateRowsAndPrint = () => {
    setModel(
      { ...model, filtered: Array.from(apiRef.current.getVisibleRowModels().values()) },
      () => window.print()
    );
  };


  useEffect(() => {
    // console.log("180 - useEffect... dispatch, scenarios, user, t");
    document.title = t('scenarios.title');

    // console.log("138 - user=", user);
    // console.log("550 - scenarios=", scenarios);

    let tmp = [];

    // if (groups.length === 0) get({ type: 'group' }).then(res => {
    //   if (res.success) {
    //     // console.log("561 - res.groups=", res.groups);
    //     setGroups(res.groups);
    //   }
    // });

    if (scenarios.length === 0) {
      setLoaded(false);
      setLoading(true);

      const locations = user.locations.map(loc => loc.id);

      // console.log("554 - locations=", locations);
      getScenarios(locations, 1).then(res => {
        // console.log("556 - res=", res);

        if (!res.success) {
          toast(decodeHTMLEntities(t('scenarios.errors.' + res)), { type: 'error' });
        } else {
          // console.log("557 - res.scenarios=", res.scenarios);
          dispatch({ settingsScenarios: res.scenarios });
          setScenarios(res.scenarios);
        }
        setLoaded(true);
        setLoading(false);
      });
    }
  }, [dispatch, scenarios, user, t]);

  // console.log("712 - locations=", locations);
  // console.log("370 - databV2=", databV2);
  // console.log("383 - sortModel=", sortModel);



  const linkOperator = (filterModel && filterModel.items.length > 1) ? (filterModel && filterModel.linkOperator) || "and" : "and";

  const newFilteredRows = _.filter(scenarios, row => {

    let keepIt;
    // console.log("-------------------");
    // console.log("903 - row=", row);
    // console.log("718 - filterModel=", filterModel);

    // AND
    if (filterModel && linkOperator === "and") {
      keepIt = true;

      // console.log("906 - filterModel=", filterModel);
      for (const filter of filterModel.items) {

        const values = filter.value && filter.value.split("|");
        // console.log("9926 - values=", values);

        switch (filter.operatorValue) {
          case "contains": {
            if (filter.value) {
              const columnElement = columns.find((element) => {
                return element.field === filter.columnField;
              });
              // console.log("990 - columnElement=", columnElement);

              if (columnElement && columnElement.moduleVersionColumn === true) {

                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {

                    // console.log("998 - value=", value);
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');

                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().includes(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {

                  // console.log("1017 - row[filter.columnField]=", row["email"]);
                  const found = values.find(value =>
                    row["email"].toUpperCase().includes(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else {
                if (row[filter.columnField]) {

                  // console.log("1017 - row[filter.columnField]=", row[filter.columnField]);
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase().includes(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
            }
            break;
          }

          // case "contains": {
          //   if (filter.value && row[filter.columnField] && !row[filter.columnField].toUpperCase().includes(filter.value.toUpperCase()))
          //     keepIt = false;
          //   break;
          // }

          case "equals": {
            // if (filter.value && row[filter.columnField] && row[filter.columnField].toUpperCase() !== filter.value.toUpperCase())
            //   keepIt = false;
            if (filter.value) {

              const columnElement = columns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase() === (value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase() === (value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase() === (value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
            }
            break;
          }

          case "startsWith": {
            if (filter.value) {

              const columnElement = columns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().startsWith(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase().startsWith(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase().startsWith(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
            }
            break;
          }

          case "endsWith": {
            if (filter.value) {

              const columnElement = columns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().endsWith(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase().endsWith(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase().endsWith(value.toUpperCase())
                  )
                  if (found === undefined)
                    keepIt = false;
                }
                else
                  keepIt = false;
              }
            }
            break;
          }

          case "isEmpty": {
            const columnElement = columns.find((element) => {
              return element.field === filter.columnField;
            });
            // console.log("1152 - columnElement=", columnElement);

            if (columnElement && columnElement.moduleVersionColumn === true) {
              if (row.moduleVersion && row.moduleVersion.length) {

                // console.log("1157 - row.moduleVersion=", row.moduleVersion);
                let isThere = false;
                for (const ver of row.moduleVersion) {
                  let det = ver.module_name.split('-');

                  if (ver.module_hwid == filter.columnField) {
                    isThere = true;
                    if (det[1] !== undefined && det[1] !== null)
                      keepIt = false;
                  }
                };
                if (!isThere)
                  keepIt = false;
              }
              // else
              //   keepIt = false;

            }
            else if (filter.columnField === "owner") {
              let isThere = false;
              if (row["email"] !== '') {
                isThere = true;
                if (row["email"] !== undefined && row["email"] !== null)
                  keepIt = false;
              }
              if (!isThere)
                keepIt = false;
            }
            else {
              let isThere = false;
              if (row[filter.columnField] !== '') {
                isThere = true;
                if (row[filter.columnField] !== undefined && row[filter.columnField] !== null)
                  keepIt = false;
              }
              if (!isThere)
                keepIt = false;
            }
            break;
          }

          case "isNotEmpty": {
            const columnElement = columns.find((element) => {
              return element.field === filter.columnField;
            });
            // console.log("1190 - columnElement=", columnElement);

            if (columnElement && columnElement.moduleVersionColumn === true) {
              if (row.moduleVersion && row.moduleVersion.length) {

                // console.log("1195 - row.moduleVersion=", row.moduleVersion);

                let isThere = false;
                for (const ver of row.moduleVersion) {
                  let det = ver.module_name.split('-');

                  // console.log("1200 -ver=", ver);
                  // console.log("1201 -det=", det);
                  // console.log("1202 -filter=", filter);

                  // console.log("1258 - ver.module_hwid == filter.columnField=", ver.module_hwid == filter.columnField);
                  // console.log("1202 - det[1]=", det[1]);
                  if (ver.module_hwid == filter.columnField) {
                    isThere = true;
                    if (det[1] === undefined || det[1] === null || det[1] === "")
                      keepIt = false;
                  }
                }
                if (!isThere)
                  keepIt = false;
              }
              else
                keepIt = false;

            }
            else if (filter.columnField === "owner") {
              if (row["email"] === '' || row["email"] === undefined || row["email"] === null)
                keepIt = false;
            }
            else {
              if (row[filter.columnField] === '' || row[filter.columnField] === undefined || row[filter.columnField] === null)
                keepIt = false;
            }
            break;
          }

          default:
            keepIt = true;
        }
      }
    }
    else if (filterModel && linkOperator === "or") {
      keepIt = false;

      // console.log("1001 - filterModel=", filterModel);

      for (const filter of filterModel.items) {
        const values = filter.value && filter.value.split("|");

        switch (filter.operatorValue) {
          case "contains": {
            // if (filter.value && row[filter.columnField] && row[filter.columnField].toUpperCase().includes(filter.value.toUpperCase()))
            //   keepIt = true;
            // break;

            if (filter.value) {
              const columnElement = columns.find((element) => {
                return element.field === filter.columnField;
              });
              // console.log("1230 - columnElement=", columnElement);

              if (columnElement && columnElement.moduleVersionColumn === true) {

                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {

                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');

                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().includes(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase().includes(value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase().includes(value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
            }
            break;

            // if (filter.value) {

            //   const columnElement = columns.find((element) => {
            //     return element.field === filter.columnField;
            //   });

            //   const found = values.find(value => {
            //     // console.log("1231 - row=", row);
            //     // console.log("1232 - value=", value);
            //     // row[filter.columnField].toUpperCase().includes(value.toUpperCase())

            //     console.log("998 - value=", value);
            //     for (const ver of row.moduleVersion) {
            //       let det = ver.module_name.split('-');

            //       console.log("1002 - ver=", ver);
            //       console.log("1004 - filter=", filter);
            //       console.log("1005 - det[1]=", det[1]);

            //       if (ver.module_hwid == filter.columnField && det[1].toUpperCase().includes(value.toUpperCase())) {
            //         return ver;
            //       }
            //     };
            //   });
            //   if (found !== undefined)
            //     keepIt = true;
            // }
            // break;
          }

          case "equals": {
            // if (filter.value && row[filter.columnField] && row[filter.columnField].toUpperCase() === filter.value.toUpperCase())
            //   keepIt = true;
            // break;

            if (filter.value) {

              const columnElement = columns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase() === (value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase() === (value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase() === (value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
            }
            break;
          }

          case "startsWith": {
            // if (filter.value && row[filter.columnField] && row[filter.columnField].toUpperCase().startsWith(filter.value.toUpperCase()))
            //   keepIt = true;

            // if (filter.value && row[filter.columnField]) {
            //   const found = values.find(value =>
            //     row[filter.columnField].toUpperCase().startsWith(value.toUpperCase())
            //   )
            //   if (found !== undefined)
            //     keepIt = true;
            // }
            // break;

            if (filter.value) {

              const columnElement = columns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().startsWith(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase().startsWith(value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase().startsWith(value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
            }
            break;
          }

          case "endsWith": {
            // if (filter.value && row[filter.columnField] && row[filter.columnField].toUpperCase().endsWith(filter.value.toUpperCase()))
            //   keepIt = true;

            // if (filter.value && row[filter.columnField]) {
            //   const found = values.find(value =>
            //     row[filter.columnField].toUpperCase().endsWith(value.toUpperCase())
            //   )
            //   if (found !== undefined)
            //     keepIt = true;
            // }
            // break;

            if (filter.value) {

              const columnElement = columns.find((element) => {
                return element.field === filter.columnField;
              });
              if (columnElement && columnElement.moduleVersionColumn === true) {
                if (row.moduleVersion && row.moduleVersion.length) {
                  const found = values && values.find(value => {
                    for (const ver of row.moduleVersion) {
                      let det = ver.module_name.split('-');
                      if (ver.module_hwid == filter.columnField && det[1].toUpperCase().endsWith(value.toUpperCase())) {
                        return ver;
                      }
                    };
                  });
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else if (filter.columnField === "owner") {
                if (row["email"]) {
                  const found = values.find(value =>
                    row["email"].toUpperCase().endsWith(value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
              else {
                if (row[filter.columnField]) {
                  const found = values.find(value =>
                    row[filter.columnField].toUpperCase().endsWith(value.toUpperCase())
                  )
                  if (found !== undefined)
                    keepIt = true;
                }
              }
            }
            break;
          }

          case "isEmpty": {
            // if (row[filter.columnField] === '' || row[filter.columnField] === undefined || row[filter.columnField] === null)
            //   keepIt = true;

            const columnElement = columns.find((element) => {
              return element.field === filter.columnField;
            });
            // console.log("1082 - columnElement=", columnElement);

            if (columnElement && columnElement.moduleVersionColumn === true) {
              if (row.moduleVersion && row.moduleVersion.length) {

                /*
                let isThere = false;
                for (const ver of row.moduleVersion) {
                  let det = ver.module_name.split('-');

                  if (ver.module_hwid == filter.columnField) {
                    isThere = true;
                    if (det[1] !== undefined && det[1] !== null)
                      keepIt = false;
                  }
                };
                if (!isThere)
                  keepIt = false;
                */
                let isThere = false;
                for (const ver of row.moduleVersion) {
                  let det = ver.module_name.split('-');
                  if (ver.module_hwid == filter.columnField) {
                    isThere = true;
                    if (det[1] === undefined || det[1] === null || det[1] === "")
                      keepIt = true;
                  }
                };
                if (!isThere)
                  keepIt = true;
              }

            }
            else if (filter.columnField === "owner") {
              if (row["email"] === '' || row["email"] === undefined || row["email"] === null)
                keepIt = true;
            }
            else {
              if (row[filter.columnField] === '' || row[filter.columnField] === undefined || row[filter.columnField] === null)
                keepIt = true;
            }
            break;
          }

          case "isNotEmpty": {
            // if (row[filter.columnField] !== '' && row[filter.columnField] !== undefined && row[filter.columnField] !== null)
            //   keepIt = true;

            const columnElement = columns.find((element) => {
              return element.field === filter.columnField;
            });
            if (columnElement && columnElement.moduleVersionColumn === true) {

              if (row.moduleVersion && row.moduleVersion.length) {
                let isThere = false;
                for (const ver of row.moduleVersion) {
                  let det = ver.module_name.split('-');

                  if (ver.module_hwid == filter.columnField) {
                    isThere = true;
                    if (det[1] !== undefined && det[1] !== null && det[1] !== "")
                      keepIt = true;
                  }
                }
                if (isThere)
                  keepIt = true;
              }
            }
            else if (filter.columnField === "owner") {
              if (row["email"] !== '' && row["email"] !== undefined && row["email"] !== null)
                keepIt = true;
            }
            else {
              if (row[filter.columnField] !== '' && row[filter.columnField] !== undefined && row[filter.columnField] !== null)
                keepIt = true;
            }
            break;
          }

          default:
            keepIt = false;
        }
      }
    }
    return keepIt;
  });



  // console.log("1278 - activeGridFilter(t, GridFilterInputValue) }=", activeGridFilter(t, GridFilterInputValue));
  // console.log("856 - selected=", selected);
  // console.log("859 - initialSelectedLocations=", initialSelectedLocations);

  // console.log("1282 - locationColumnsFromDatabase=", locationColumnsFromDatabase);
  // console.log("1169 - columns=", columns);
  // console.log("1276 - scenarios=", scenarios);
  // console.log("1276 - scenarios2=", scenarios2, scenarios2.length);
  // console.log("1276 - groups=", groups);

  /*newFilteredRows*/
  let filteredRows = [];



  let tmpStr = 'sidebar.scenarios.' + modeScenariosOrModules;
  let modeScenariosOrModulesText = t(tmpStr);
  if (modeScenariosOrModules === 'modules')
    modeScenariosOrModulesText = t('scenarios.modules.title', { s: 's' });

  let totalScenariosCount = scenarios.length;
  const filteredScenarios = _.filter(scenarios, scenario => {
    let keepIt = true;

    // console.log("802 - scenario=", scenario);
    switch (modeScenariosOrModules) {
      case "all_scenarios":
        return true;
        break;

      case "myGroup_scenarios": {
        if (scenario.groups && scenario.groups.length > 0) {
          let test = scenario.groups.find(element => {
            // console.log("946 - element=", element);
            return (element === user.groupId);
          })
          return (test);
        }
        break;
      }

      case "myShared_scenarios": {
        if (user.id === scenario.owner && scenario.sharingOptions !== sharingValues.noOne)
          return true;
        break;
      }

      case "myPrivate_scenarios": {
        if (user.id === scenario.owner && scenario.sharingOptions === sharingValues.noOne)
          return true;
        break;
      }

      case "sft_scenarios": {
        if (user.roleId <= roles.stAdmin && scenario.sharingOptions === sharingValues.allStAdmins)
          return true;
        break;
      }

      case "allGroups_scenarios": {
        if (
          user.roleId <= roles.stAdmin && scenario.groups && scenario.groups.length > 0 //(
          //   scenario.sharingOptions === sharingValues.allGroupAdmins || scenario.sharingOptions === sharingValues.allGroupUsers
          // )
        )
          return true;
        break;
      }

      case "currentGroups_scenarios": {
        // console.log("938 - scenario=", scenario);

        if (user.roleId <= roles.stAdmin && scenario.groups && scenario.groups.length > 0 && selected && selected.groups) {
          //   scenario.sharingOptions === sharingValues.allGroupAdmins || scenario.sharingOptions === sharingValues.allGroupUsers
          // let test = selected.groups.find(element => {
          //   retscenario.groups[0] 
          // })       
          let test = selected.groups.find(element => {
            // console.log("946 - element=", element.value, scenario.groups[0], element.value === scenario.groups[0]);
            return (element.value === scenario.groups[0]);
          })
          //console.log("949 - test=", test);  
          return (test);
        }
        return false;
        break;
      }

      default:
        return false;
    }
    return false;
  });
  let filteredScenariosCount = filteredScenarios.length;


  // console.log("1602 - user=", user);

  return (
    <div className="admin locations">
      <DataGridPro
        // autoPageSize
        apiRef={apiRef}
        loading={loading}
        // checkboxSelection
        disableSelectionOnClick

        pageSize={settings.pageSize}
        pagination={settings.pagination}
        rows={filteredScenarios}
        columns={columns}

        onSelectionModelChange={selected => setModel({ ...model, selected })}
        columnTypes={{ activeFilter: activeGridFilter(t, GridFilterInputValue) }}
        onPageSizeChange={pageSize => changeSettings(t, 'pageSize', pageSize, settings, appDispatch)}

        getRowClassName={(params) => {
          return params.id === highlightedRow ? "highlight" : "";
        }}
        onRowClick={o => {
          if (o.id === highlightedRow)
            setHighlightedRow(null);
          else
            setHighlightedRow(o.id)
        }}

        onRowDoubleClick={o => {
          // console.log("1449 - o=", o);
          const r = newFilteredRows.find((rowElement) => {
            return rowElement.id === o.id;
          });
          // console.log("1453 - r=", r);

          if (r) {
            let forceDisabled = false;
            if (r.owner !== null && user.roleId >= roles.stAdmin) {
              forceDisabled = true;
              if (r.owner === user.id)
                forceDisabled = false;
            }

            if (!forceDisabled)
              setSelectedScenario(r);
          }
        }}

        onColumnWidthChange={(params, event) => {
          // console.log("1410 - onColumnWidthChange=", params, event)
          changeColumnsWidth(params);
        }}
        onColumnVisibilityChange={(params, event) => {
          changeColumnsVisibility(params);
        }}
        onColumnOrderChange={(params, event) => {
          if (oldIndex === null) {
            setReorderedColumn(params.field)
            setOldIndex(params.oldIndex);
          }
          setTargetIndex(params.targetIndex);
        }}

        sortModel={sortModel}
        onSortModelChange={(model) => handleSortChange(model)}

        // filterMode="server"
        // filterModel={filterModel}

        // onFilterModelChange={(model) => {
        //   console.log('1468 - model=', model);
        //   setFilterModel(model);
        // }}
        disableAddFilterButton={false}

        localeText={{
          ...(localStorage.getItem('lang') === 'fr' ? frFR : enUS).props.MuiDataGrid.localeText,
          ...translatedGridFilters(t)
        }}

        components={{
          ColumnMenu: CustomColumnMenu,
          ColumnSortedAscendingIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks }}
            >
              arrow_upward
            </div>
          ),
          ColumnSortedDescendingIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks }}
            >
              arrow_downward
            </div>
          ),
          ColumnUnsortedIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks, opacity: '0.4' }}
            >
              remove
            </div>
          ),
          LoadingOverlay,
          Toolbar: () => (
            <div className="content__header">
              <h2>
                {/* {t('scenarios.title')} */}

                {user.roleId === roles.user && (
                  <div className={'dropdown'} style={{ display: "block", alignItems: 'center' }}>
                    <ul className="dropdown__list" id="modeScenariosOrModules" style={{ fontSize: "15px" }}>
                      <li onClick={() => handleSetModeScenariosOrModules('all_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('sidebar.scenarios.all_scenarios')}
                      </li>
                      <li onClick={() => handleSetModeScenariosOrModules('myGroup_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('sidebar.scenarios.myGroup_scenarios')}
                      </li>
                      <li onClick={() => handleSetModeScenariosOrModules('myShared_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('sidebar.scenarios.myShared_scenarios')}
                      </li>
                      <li onClick={() => handleSetModeScenariosOrModules('myPrivate_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('sidebar.scenarios.myPrivate_scenarios')}
                      </li>
                    </ul>

                    <h2
                      className="dropdown__content"
                      style={{
                        display: "flex",
                        position: "relative",
                        alignItems: "center",
                        cursor: "pointer",
                        padding: "0px",
                        marging: "0px 0px 8px 0px",
                        transition: "0.25s",
                        userSelect: "none",
                        textAlign: 'center'
                      }}
                      onClick={() => document.querySelector('#modeScenariosOrModules').classList.toggle('open')}
                    >
                      <span className="dropdown__open"> </span>
                      <span className="dropdown__open dropdown__title">{modeScenariosOrModulesText}</span>
                      <span className="dropdown__open material-icons-round dropdown__arrow">expand_more</span>
                    </h2>
                  </div>
                )}

                {user.roleId === roles.admin && (
                  <div className={'dropdown'} style={{ display: "block", alignItems: 'center' }}>
                    <ul className="dropdown__list" id="modeScenariosOrModules" style={{ fontSize: "15px" }}>
                      <li onClick={() => handleSetModeScenariosOrModules('all_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('sidebar.scenarios.all_scenarios')}
                      </li>
                      <li onClick={() => handleSetModeScenariosOrModules('myGroup_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('sidebar.scenarios.myGroup_scenarios')}
                      </li>
                      <li onClick={() => handleSetModeScenariosOrModules('myShared_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('sidebar.scenarios.myShared_scenarios')}
                      </li>
                      <li onClick={() => handleSetModeScenariosOrModules('myPrivate_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('sidebar.scenarios.myPrivate_scenarios')}
                      </li>
                    </ul>

                    <h2
                      className="dropdown__content"
                      style={{
                        display: "flex",
                        position: "relative",
                        alignItems: "center",
                        cursor: "pointer",
                        padding: "0px",
                        marging: "0px 0px 8px 0px",
                        transition: "0.25s",
                        userSelect: "none",
                        textAlign: 'center'
                      }}
                      onClick={() => document.querySelector('#modeScenariosOrModules').classList.toggle('open')}
                    >
                      <span className="dropdown__open"> </span>
                      <span className="dropdown__open dropdown__title">{modeScenariosOrModulesText}</span>
                      <span className="dropdown__open material-icons-round dropdown__arrow">expand_more</span>
                    </h2>
                  </div>
                )}

                {user.roleId <= roles.stAdmin && (
                  <div className={'dropdown'} style={{ display: "block", alignItems: 'center' }}>
                    <ul className="dropdown__list" id="modeScenariosOrModules" style={{ fontSize: "15px" }}>
                      <li onClick={() => handleSetModeScenariosOrModules('all_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('sidebar.scenarios.all_scenarios')}
                      </li>
                      <li onClick={() => handleSetModeScenariosOrModules('sft_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('sidebar.scenarios.sft_scenarios')}
                      </li>
                      <li onClick={() => handleSetModeScenariosOrModules('allGroups_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('sidebar.scenarios.allGroups_scenarios')}
                      </li>
                      <li onClick={() => handleSetModeScenariosOrModules('currentGroups_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('sidebar.scenarios.currentGroups_scenarios')}
                      </li>
                      <li onClick={() => handleSetModeScenariosOrModules('myShared_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('sidebar.scenarios.myShared_scenarios')}
                      </li>
                      <li onClick={() => handleSetModeScenariosOrModules('myPrivate_scenarios')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('sidebar.scenarios.myPrivate_scenarios')}
                      </li>
                    </ul>

                    <h2
                      className="dropdown__content"
                      style={{
                        display: "flex",
                        position: "relative",
                        alignItems: "center",
                        cursor: "pointer",
                        padding: "0px",
                        marging: "0px 0px 8px 0px",
                        transition: "0.25s",
                        userSelect: "none",
                        textAlign: 'center'
                      }}
                      onClick={() => document.querySelector('#modeScenariosOrModules').classList.toggle('open')}
                    >
                      <span className="dropdown__open"> </span>
                      <span className="dropdown__open">{modeScenariosOrModulesText}</span>
                      <span
                        className="dropdown__open material-icons-round dropdown__arrow"
                        style={{ padding: "4px 0px 0px 0px" }}
                      >
                        expand_more
                </span>
              </h2>
                  </div>
                )}

                {'\u2000\u2000'}
                <span style={{ color: colors.softthinks, padding: "0px 0px 0px 0px" }}>
                  {/* {loading ? (t('global.loading') + '...') : apiRef.current.getVisibleRowModels().size} */}
                  {loading ? (t('global.loading') + '...') : ((modeScenariosOrModules === 'all_scenarios') ? '(' + totalScenariosCount + ')' : '(' + filteredScenariosCount + '/' + totalScenariosCount + ')'  /*apiRef.current.getVisibleRowModels().size*/)}
                </span>
              </h2>



              <div className="options">
                <GridToolbarContainer>
                  <GridToolbarFilterButton />
                  <GridToolbarColumnsButton />
                </GridToolbarContainer>
                <span className="separation" />

                <div className="actions">
                  <Export
                    apiRef={apiRef}
                    loading={loading}
                    model={model}
                    setModel={setModel}
                  /> {/* Excel / PDF Download */}

                  <button title={t('global.actions.print')} className="button icon" onClick={updateRowsAndPrint} disabled={loading}>
                    <span className="material-icons-round">print</span> {/* Print */}
                  </button>
                </div>
                <span className="separation" />

                <Button
                  className="button"
                  onClick={() => setSelectedScenario({})}
                  startIcon={<span className="material-icons-round">add_circle_outline</span>}
                >{t('scenarios.create.button')}</Button>
              </div>
            </div>
          ),

          Footer: () => (
            <div className="datagrid__footer">
              <GridFooter />
              <div className="checkbox">
                <input
                  id="pagination"
                  type="checkbox"
                  defaultChecked={settings.pagination}
                  onChange={() => changeSettings(t, 'pagination', !settings.pagination, settings, appDispatch)}
                />
                <label htmlFor="pagination">PAGINATION</label>
              </div>
            </div>
          )
        }}
      />

      {selectedOption()}

      {/* {(scenarios.length > 0) && <Print scenarios={rowsToPrint()} />} */}
    </div>
  );
}
